import "core-js/modules/es.object.to-string";
import axios from 'axios';
import { setToken, getToken } from '@/utils/auth';
import { Message } from 'element-ui';
import { Loading } from 'element-ui';
import store from '@/store';
var loading = null;
var pending = {};
var CancelToken = axios.CancelToken;

var removePending = function removePending(key) {
  var isRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (pending[key] && isRequest) {
    pending[key]('取消重复请求');
  }

  delete pending[key];
};

var getRequestIdentify = function getRequestIdentify(config) {
  var url = config.url;

  if (config.method === 'post') {
    return encodeURIComponent(config.url + JSON.stringify(config.data));
  }

  return encodeURIComponent(url + JSON.stringify(config.params));
};

var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 请求地址
  timeout: 60000,
  // request timeout
  withCredentials: true
}); // request interceptor

service.interceptors.request.use(function (config) {
  // get请求取消强缓存
  if (config.method === 'get') {
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
  }

  var requestData = getRequestIdentify(config);
  removePending(requestData, true);
  config.cancelToken = new CancelToken(function (c) {
    pending[requestData] = c;
  }); // 全局loading

  if (config.isDefaultLoading) {
    loading = Loading.service();
  } // 只用于表格loading


  if (config.tabelLoading) {
    store.state.tabelLoading = true;
  }

  if (getToken()) {
    config.headers['Authorization'] = getToken();
  }

  return config;
}, function (error) {
  Promise.reject(error);
});
service.interceptors.response.use(function (response) {
  if (response.headers.authorization && response.headers.authorization !== getToken()) {
    setToken(response.headers.authorization);
  }

  var res = response.data;
  var code = res.code;

  if (response.config.isDefaultLoading) {
    loading.close();
  }

  if (response.config.tabelLoading) {
    store.state.tabelLoading = false;
  } // code:34023 是未注册账号


  if (code !== 10000 && code !== 34023) {
    if (code === 10915) {
      Message({
        message: '您的账号已在其它终端登录，请重新登录！',
        type: 'error'
      });
      setTimeout(function () {
        store.dispatch('user/logout');
      });
      return Promise.reject(res);
    }

    if (code === 10401 || code === 10403) {
      Message({
        message: res.message || res.msg || 'token无效,请重新登录',
        type: 'error'
      });
      setTimeout(function () {
        store.dispatch('user/logout');
      });
      return Promise.reject(res);
    }

    if (!response.config.noToast) {
      Message({
        message: res.msg || res.error || '服务异常',
        type: 'error'
      });
    }

    return Promise.reject(res);
  } else {
    return res;
  }
}, function (error) {
  loading && loading.close();
  store.state.tabelLoading = false;
  return Promise.reject(error);
});
export default service;